import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import * as actions from "../../store/actions";
import service from "../../services/userManagement.service";
import axiosInterceptors from "../../hoc/axiosInterceptors";
import Textbox from "../../components/Textbox";
import Checkbox from "../../components/Checkbox";
import Version from "../../components/Version";
import Button from "../../components/Button";
import ErrorMessage from "../../components/ErrorMessage";
import Logo from "../../components/Logo";
import joi from "joi";
import Form from "../../components/Form";
import "./Login.css";
import { Spinner } from "../../components";

class ForgotPassword extends Component {
  constructor(props) {
    super(props);
    this.state = this.initialState;
  }

  initialState = {
    isSubmit: false,
    controls: {
      email: {
        value: "",
        valid: false,
        validMessage: "",
        touched: false,
        validation: joi.string().required()
      }
    }
  };

  componentWillReceiveProps(nextProps) {
    this.resetForm();
  }

  componentWillUnmount() {
    this.props.onForgotPasswordCleanMessage();
  }

  resetForm() {
    this.setState(this.initialState);
  }

  onSubmitHandler = event => {
    event.preventDefault();
    this.setState({ ...this.state, isSubmit: true });
    Object.keys(this.state.controls).map(controlName => {
      console.log(this.state.controls[controlName].valid);
      this.formIsValid =
        this.state.controls[controlName].valid && this.formIsValid;
    });
    console.log(this.formIsValid);
    if (this.formIsValid === true) {
      this.props.onSendForgotPasswordEmail(this.state.controls.email.value);
    }
  };

  checkValidity = (value, validation) => {
    let result = joi.validate(value, validation);
    return result;
  };

  formIsValid = false;

  onChangeHandler = (controlName, value) => {
    this.formIsValid = true;
    var validateResault = this.checkValidity(
      value,
      this.state.controls[controlName].validation
    );
    // this.formIsValid = validateResault.error ? false : true;
    const updatedControls = {
      ...this.state.controls,
      [controlName]: {
        ...this.state.controls[controlName],
        value: value,
        valid: validateResault.error ? false : true,
        validMessage: validateResault.error
          ? validateResault.error.details[0].message
          : "",
        touched: true
      }
    };
    this.setState({ ...this.state, controls: updatedControls });
    console.log(this.state);
  };

  ForgotPasswordHandler = () => {
    this.props.onForgotPasswordStatus(false);
  };

  render() {
    return (
      <div className="body text-center wrapper">
        <Form classNames="form-signin">
          {this.props.loading && <Spinner />}
          <Logo />
          <h1 className="h3 mb-3 font-weight-normal">Forgot Password</h1>
          <Textbox
            type="text"
            label=""
            placeholder="Email"
            id="email"
            onChange={this.onChangeHandler}
            value={this.state.controls.email.value}
            valid={this.state.controls.email.valid}
            validMessage={this.state.controls.email.validMessage}
            isSubmited={this.state.isSubmit}
          />
          <Button
            // disable={this.formIsValid ? "" : disabled}
            className="btn btn-lg btn-primary btn-block "
            type="submit"
            label="Reset Password"
            onClick={event => this.onSubmitHandler(event)}
          />
          <div className="col-md-12 p-0 mt-4">
            <p>
              <a
                href="#"
                className="text-primary"
                onClick={this.ForgotPasswordHandler}
              >
                Back to login page
              </a>
            </p>
          </div>
          <div className="col-md-12 p-0 mt-3">
            <ErrorMessage
              {...this.props}
              info={this.props.forgotPasworSuccessMessage}
              //error={this.props.forgotPasworFaileMessage}
              className="col-md-12"
            />
          </div>
          <Version />
        </Form>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    loading: state.auth.loading,
    error: state.auth.error,
    isAuthenticated: state.auth.token !== null,
    authRedirectPath: state.auth.authRedirectPath,
    forgotPasworSuccessMessage: state.auth.forgotPasworSuccessMessage,
    forgotPasworFaileMessage: state.auth.forgotPasworFaileMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onLogin: (email, password) => dispatch(actions.login(email, password)),
    onForgotPasswordStatus: status =>
      dispatch(actions.forgotPasswordStatus(status)),
    onSendForgotPasswordEmail: email =>
      dispatch(actions.sendForgotPasswordEmail(email)),
    onForgotPasswordCleanMessage: () =>
      dispatch(actions.forgotPasswordCleanMessage())
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(axiosInterceptors(ForgotPassword, service));
